// extracted by mini-css-extract-plugin
export var button = "_r-0";
export var buttonContent = "_r-d";
export var buttonGroup = "_r-b";
export var dontRestrainIconWidth = "_r-9";
export var dropdownButton = "_r-a";
export var iconContainer = "_r-8";
export var lg = "_r-4";
export var md = "_r-3";
export var pending = "_r-e";
export var sm = "_r-2";
export var spinner = "_r-c";
export var squared = "_r-7";
export var xl = "_r-5";
export var xs = "_r-1";
export var xxl = "_r-6";